import { CollaborationStatus } from '../../../API';

export interface CollaborationItem {
  collaborationId?: string;
  name: string;
  orgType: string;
  description: string;
  objective: string;
  status: CollaborationStatus;
  lastModifiedAt: string;
  createdBy: string;
  partnerOrgType: string;
  partnerEmail: string[];
  lastModifiedBy?: string;
  ownerDatasets?: Dataset[];
  partnerDatasets?: Dataset[];
  partnerInviteMessage: string;
}

export interface Dataset {
  tableName: string;
  schemaName: string;
  dataConnectionId: string;
  dataConnectionName: string;
  status?: string;
  isSelected?: boolean;
}

export enum CollaborationAction {
  EDIT = 'edit',
  DELETE = 'delete',
  MANAGE_DATASETS = 'manage_datasets',
  PAUSE = 'pause',
  CLOSE = 'close',
  RESUME = 'resume',
  ACCEPT = 'accept',
  DECLINE = 'decline',
  RESEND = 'resend',
}
